import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Banner, BannersResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class BannersDataService {

  private uri: string = `${environment.apiUrl}banners`;
  private cacheKey: string = 'banners.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getBanner(id: number): Observable<Banner|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getBanners(parameters: {[param: string]: string | string[]}): Observable<BannersResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addBanner(data: Banner): Observable<Banner|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addBanners(data: Banner[]): Observable<Banner[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateBanner(data: Banner): Observable<Banner|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateBanners(data: Banner[]): Observable<Banner[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchBanner(data: Banner): Observable<Banner|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchBanners(data: Banner[]): Observable<Banner[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteBanner(data: Banner): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteBanners(data: Banner[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((banner) => {
      ids.push(banner.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
